export default {
  messages: [],
  message: undefined,
};
